import { apiFetch } from './client';

// ============================================================
// Sweeps API client.
// Mirror del endpoint /api/sweeps/* del backend.
// ============================================================

export interface DailyBreakdown {
  dayName: string;
  trades: number;
  totalPnL: number;
  winRate: number;
  profitFactor: number | 'Infinity';
  avgWinDurationMin: number;
  avgLossDurationMin: number;
}

export interface WeeklyBreakdown {
  weekNumber: number;
  weekStart: string;
  weekEnd: string;
  trades: number;
  totalPnL: number;
  winRate: number;
  profitFactor: number | 'Infinity';
  avgWinDurationMin: number;
  avgLossDurationMin: number;
  longPnL: number;
  shortPnL: number;
  dailyBreakdown: DailyBreakdown[];
}

export interface WeeklyBreakdownResponse {
  sweepId: string;
  weeks: WeeklyBreakdown[];
}

export function fetchWeeklyBreakdown(sweepId: string): Promise<WeeklyBreakdownResponse> {
  return apiFetch<WeeklyBreakdownResponse>(
    `/api/sweeps/${encodeURIComponent(sweepId)}/weekly-breakdown`,
  );
}
